import * as yup from "yup";

const loginSchema = yup.object({
    email: yup
        .string()
        .trim()
        .lowercase()
        .email("Please enter a valid email address")
        .required("Email is required"),

    password: yup
        .string()
        .min(6, "Password must be at least 6 characters")
        .required("Password is required"),
});

const forgotPasswordSchema = yup.object({
    email: yup
        .string()
        .trim()
        .lowercase()
        .email("Please enter a valid email address")
        .required("Email is required"),
});

const resetPasswordSchema = yup.object({
    password: yup
        .string()
        .min(6, "Password must be at least 6 characters")
        .required("Password is required"),

    confirmPassword: yup
        .string()
        .oneOf([yup.ref("password"), null], "Passwords must match")
        .required("Confirm Password is required"),
});

const registerSchema = yup.object().shape({
    firstName: yup.string().trim().required("First name is required"),

    lastName: yup.string().trim().required("Last name is required"),

    email: yup
        .string()
        .trim()
        .lowercase()
        .email("Invalid email address")
        .required("Email is required"),

    dob: yup
        .date()
        .typeError("Date of birth is required")
        .required("Date of birth is required"),

    userType: yup.string().required("User type is required"),

    gender: yup.string().required("Gender is required"),

    postalCode: yup.string().trim().required("Postal code is required"),

    password: yup
        .string()
        .min(6, "Password must be at least 6 characters")
        .required("Password is required"),

    confirmPassword: yup
        .string()
        .oneOf([yup.ref("password"), null], "Passwords must match")
        .required("Confirm Password is required"),
});

export {
    forgotPasswordSchema,
    loginSchema,
    registerSchema,
    resetPasswordSchema,
};
